import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./index.css"
import MainDashboard from "./layouts/MainDashboard.js";
import Auth from "./layouts/Auth";
import {CookiesProvider} from "react-cookie";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <CookiesProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/auth/*" exact element={<Auth/>}/>
        <Route path="*" element={<MainDashboard/>}/>
      </Routes>
    </BrowserRouter>
  </CookiesProvider>
);
